import React from 'react';
import './resultsC.scss';

import FilterDisplay from '../filterDisplay/filterDisplay';
import ResultDisplay from '../resultDisplay/resultDisplay';
// eslint-disable-next-line camelcase
import Preferences_MT from '../preferences/mobile-tablet/preferences_mt';
// eslint-disable-next-line camelcase
import Preferences_D from '../preferences/desktop/preferences_d';

import check from '../../../assets/check.svg';

class ResultsC extends React.Component {
    render() {
        const { modal, headerInfo } = this.props;

        return (
            <>
                <div className="done-banner default">
                    <img className="check icon" src={check} alt="" />
                    <div className="banner-message">Done! Scroll down to see your results.</div>
                </div>

                <div className="main-results-container default c">
                    {/* eslint-disable-next-line react/jsx-pascal-case */}
                    <Preferences_D />

                    <div className="results">
                        <div className="content-container">
                            <h1 className="results-title">{headerInfo.title}</h1>
                            {headerInfo.attributionLine ? (
                                <p className="attributionLine">{headerInfo.attributionLine}</p>
                            ) : null}

                            <div className="results-intro">
                                <p
                                    className="description"
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{ __html: headerInfo.description }}
                                />
                                {modal || null}
                            </div>
                        </div>

                        <FilterDisplay />

                        {/* eslint-disable-next-line react/jsx-pascal-case */}
                        <Preferences_MT />

                        <ResultDisplay />
                    </div>
                </div>
            </>
        );
    }
}

export default ResultsC;
